import React from "react";
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import kotel2 from './images/כותל.jpg';
import gilgal from './images/גלגל.jpg';
import galed from './images/גלעד.jpg';
import shone_alchot from './images/שונה_הלכות.jpg';
import chaye_olam from './images/חיי_עולם.jpg';
import kotel from './images/כותל.jpg';
const images = [
  kotel2,
  gilgal,
  galed,
  shone_alchot, 
  chaye_olam
]
function Main() {
    return(
    <div
     style={{ backgroundImage:`url(${kotel})`
     , backgroundSize: 'cover'
     , minHeight: '100vh'
     }}
     >


    {/* Main */}
    <Container className="text-center py-5">
      <Row className="justify-content-center mb-5">
        <Col md={6}>
          <Carousel fade interval={5000}>
          {images.map((src, index) => (
    <Carousel.Item key={index}>
      <img
        className="d-block w-100"
        src={src}
        alt={`נכס ${index + 1}`}
        style={{ height: '300px', objectFit: 'cover' }}
      />
    </Carousel.Item>
  ))}
          </Carousel>
        </Col>
      </Row>
      <Container className="py-5">
  <Row className="justify-content-center">
    <Col md={10} lg={8}>
      <div className="bg-light p-4 rounded shadow text-end">
        <h2 className="fs-4">
          "שבת בעתיקה" מציע מגוון אפשרויות אירוח ברובע היהודי בירושלים.<br />
          באתר מבחר דירות לשבת וחג, השכרת דירות לתקופות קצרות או ארוכות,<br />
         ומכירת דירות ברובע היהודי.<br />
          הוקם בטבת תשע"ז ע"י בני משפחה מתושבי הרובע היהודי בעיר העתיקה בירושלים.<br /><br />
          <strong>ליצירת קשר:</strong><br />
          מייל: <a href="mailto:shabatkotel@gmail.com">shabatkotel@gmail.com</a><br />
          טלפון: <a href="tel:0529936265">052-9936265</a>
        </h2>
      </div>
    </Col>
  </Row>
</Container>
<Row className="mb-5">
  {[
    { text: 'דירות לשבת', link: '/product', state: { typeHome: 'home_shabat' } },
    { text: 'דירות למכירה', link: '/product', state: { typeHome: 'sal' } },
    { text: 'דירות להשכרה', link: '/product', state: { typeHome: 'kait' } },
  ].map((item, index) => (
    <Col key={index} xs={12} md={4} className="mb-3">
      <Link
        to={item.link}
        state={item.state}
        className="btn btn-light w-100"
      >
        {item.text}
      </Link>
    </Col>
  ))}
</Row>


    </Container>
  </div>
    ) 
}

export default Main